import $ from 'jquery';
import _ from 'lodash';
import util from 'util/Util.js';

import BasePropertyView from 'BasePropertyView.js'
import Immutable from 'immutable';
import contentTemplate from 'properties/style/background-picture.ejs';
import assetCollection from 'AssetCollection.js';
import eventBus from 'EventBus.js';
import themeService from 'ThemeService.js';
import pageSyncService from 'PageSyncService.js';
import configService from 'ConfigService';
import constants    from 'Constants';
import textConstants    from 'TextConstants';
import restService from 'RestService.js';
import listService from 'ListService';
import undoService from 'UndoService';

class StyleBackgroundPictureView extends BasePropertyView {
    
    initialize(opts) {     
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};
        this.viewTitle = _.get(opts, 'config.viewTitle') || '';

        // !! Use Specific ids for hooking events when possible !!
        this.events = {
            'change #stylePictureSelect, #backgroundImageStyle': 'updateSelectAttributes',
            'change #preloadImage': 'updateCheckAttributes'
        };

        if (!this.model.get('groupBackgroundImageStyle')) {
            this.model.set('groupBackgroundImageStyle', '', constants.MODEL_SILENT);
        }

        if (!this.model.get('groupBackgroundImageTag')) {
            this.model.set('groupBackgroundImageTag', '', constants.MODEL_SILENT);
        }

        if (!this.model.get('viewTitle')){
            this.model.set('viewTitle',this.viewTitle, constants.MODEL_SILENT);
        }

        this.listenTo(eventBus, 'resetPageStyle', this.resetPage);
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckAttributes(ev) {
        ev.stopPropagation();
        let oldPreloadImage = this.model.get('preloadImage');
        if (util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent('preloadImage',ev.currentTarget.checked,this.model,this.render.bind(this),'GroupPropertyChange');
        }else{
            this.model.set("preloadImage", ev.currentTarget.checked);
        }

        undoService.add({
            undo:() =>{
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent('preloadImage',oldPreloadImage,this.model,this.render.bind(this),'GroupPropertyChange');

                }else{
                    this.model.set('preloadImage', oldPreloadImage);
                }
            },
            redo:() =>{
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent('preloadImage',ev.currentTarget.checked,this.model,this.render.bind(this),'GroupPropertyChange');
                }else{
                    this.model.set('preloadImage', ev.currentTarget.checked);
                }
            }
        },textConstants.UNDO_PROP_CHANGE)
    }

    updateSelectAttributes(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldGroupBackgroundImageTag = this.model.get('backgroundImageStyle');
        const oldPropVal = this.model.get(propName);
        const oldAssetId = this.model.get('assetId');
        const oldBackgroundAssetId = this.model.get('backgroundImageAssetId');
        const oldBgImage = this.model.get('bgImage');





        const assetId = this.model.get('assetId');
        var imgTag = restService.getAssetURL(assetId);
        var styleProps = "";
        
        if (propName === "backgroundImageStyle") {
            this.model.set('groupBackgroundImageTag', imgTag, constants.MODEL_SILENT);
            if (util.isGroupContainer(this.model.get('factoryKey'))){
                util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')

            }else{
                this.model.set(propName, propVal);
            }

            if (this.isAPage()) {
                pageSyncService.renderCurrentPageView();
            }
        } else if (propName === "stylePictureSelect") {
            this.model.set('assetId', propVal, constants.MODEL_SILENT);
            if (this.isAPage()) {
                this.model.set('backgroundImageAssetId', propVal, constants.MODEL_SILENT);
                pageSyncService.renderCurrentPageView();
            }

            const factoryKey = this.model.get('factoryKey');
            if (constants.GROUP_KEYS.contains(factoryKey) || factoryKey === 'control_section') {
                this.model.set('bgImage', propVal, constants.MODEL_SILENT);
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent('backgroundImageAssetId',propVal,this.model,this.render.bind(this),'GroupPropertyChange')

                }else{
                    this.model.set('backgroundImageAssetId', propVal);
                }
            }
        }

        themeService.deattachTheme(this);


        undoService.add({
            undo: () =>{
                if (propName === "backgroundImageStyle") {
                    this.model.set('groupBackgroundImageTag', oldGroupBackgroundImageTag, constants.MODEL_SILENT);
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,oldPropVal,this.model,this.render.bind(this),'GroupPropertyChange');
                    }else{
                        this.model.set(propName, oldPropVal);
                    }

                    if (this.isAPage()) {
                        pageSyncService.renderCurrentPageView();
                    }
                } else if (propName === "stylePictureSelect") {
                    this.model.set('assetId', oldAssetId, constants.MODEL_SILENT);
                    if (this.isAPage()) {
                        this.model.set('backgroundImageAssetId', oldBackgroundAssetId, constants.MODEL_SILENT);
                        pageSyncService.renderCurrentPageView();
                    }
                    if (constants.GROUP_KEYS.contains(this.model.get('factoryKey'))) {
                        this.model.set('bgImage', oldBgImage, constants.MODEL_SILENT);

                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent(propName,oldPropVal,this.model,this.render.bind(this),'GroupPropertyChange');
                        }else{
                            this.model.set('backgroundImageAssetId', oldBackgroundAssetId);
                        }
                    }
                }
            },
            redo:() => {
                if (propName === "backgroundImageStyle") {
                    this.model.set('groupBackgroundImageTag', imgTag, constants.MODEL_SILENT);
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')

                    }else{
                        this.model.set(propName, propVal);
                    }

                    if (this.isAPage()) {
                        pageSyncService.renderCurrentPageView();
                    }
                } else if (propName === "stylePictureSelect") {
                    this.model.set('assetId', propVal, constants.MODEL_SILENT);
                    if (this.isAPage()) {
                        this.model.set('backgroundImageAssetId', propVal, constants.MODEL_SILENT);
                        pageSyncService.renderCurrentPageView();
                    }
                    if (constants.GROUP_KEYS.contains(this.model.get('factoryKey'))) {
                        this.model.set('bgImage', propVal, constants.MODEL_SILENT);

                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')

                        }else{
                            this.model.set('backgroundImageAssetId', propVal);
                        }

                    }
                }
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    resetPage() {
        console.warn("Bus got executed ...");
    }

    isAReport() {
        return listService.mainKind === 'R';
    }

    isAGroupContainer() {
        let isControlGroup = ['control_group','control_checkbox_group', 'control_radio_button_group'].includes(this.model.get('factoryKey'));

        if (isControlGroup) {
            let isPreloadUndefined = this.model.get('preloadImage') === undefined;

            if (isPreloadUndefined) {
                // PF-3485 Silencing as it will trigger a change in Undo Service.
                this.model.set('preloadImage', true, constants.MODEL_SILENT);
            }
        }

        return isControlGroup;
    }

    isAPage() {
        let result = false;
        this.model.get('factoryKey') === 'page_instance' || this.model.get('factoryKey') === 'layout_page'
            || this.model.get('factoryKey') === 'report_page' ? result = true : result = false;
        return result;
    }

    render() {        
        // PF-2698 Silencing events as they are stacked on the UndoService on every click on the canvas.
        this.model.set('isReportForm', this.isAReport(), constants.MODEL_SILENT);
        this.model.set('isGroupContainer', this.isAGroupContainer(), constants.MODEL_SILENT);
        this.model.set('isPageForm', this.isAPage(), constants.MODEL_SILENT);
        this.model.set('isSectionControl', this.model.get('factoryKey') === 'control_section', constants.MODEL_SILENT);
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        assetCollection.forEach(asset => {
            var opt = document.createElement('option');
            opt.text = asset.get('name');
            opt.value = asset.get('id');
            $('#stylePictureSelect').append(opt);
        });

        if (this.isAPage()) {
            $('#stylePictureSelect').find('option[value='
                + themeService.resolve(this.model.get('backgroundImageAssetId')) + ']').attr('selected', true);
        } else if (constants.GROUP_KEYS.contains(this.model.get('factoryKey')) || this.model.get('factoryKey') === 'control_section') {
            if (this.model.get('backgroundImageAssetId') !== '~groupBgImage') {                
                $('#stylePictureSelect').val(this.model.get('backgroundImageAssetId'));
            }else if (themeService.resolve('~groupBgImage') !== 'null') {
                $('#stylePictureSelect').val(themeService.resolve('~groupBgImage'));           
            }
            else{
                 $('#stylePictureSelect').val('None');
            }
        } else {
            if (this.model.get('assetId')) {
                var ddValue = this.model.get('assetId');
                $('#stylePictureSelect').val(ddValue);
            }
        }

        if (this.model.get('backgroundImageStyle')) {
            var ddValue = this.model.get('backgroundImageStyle');
            $('#backgroundImageStyle').val(ddValue);
        }
        //set selected index to model value

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }
 
        let preloadImageObj = $('#preloadImage');
        if (preloadImageObj) {
            $('#preloadImage').prop("checked", util.isTrue(this.model.get('preloadImage')));
        } 

        this.delegateEvents();

        return this;
    }

}

export default StyleBackgroundPictureView;
